import {
	retrieveRawInitData,
} from '@tma.js/sdk-react'

export function getTelegramInitData(): string | null {
	const initDataRaw = retrieveRawInitData()

	return typeof initDataRaw === 'string' ?
		initDataRaw :
		null
}
